import { polygonOrientation, rotatePoint, midpointCartesian } from "./geometry";
import * as turf from "@turf/turf";

// 스와스 생성 함수
export const generateSwaths = (
  headlandCoords,
  workingWidth = 1.5,
  Direction = "X"
) => {
  try {
    // 헤드랜드 폴리곤 생성
    const headland = turf.polygon([headlandCoords]);

    // 폴리곤 중심점 찾기 (좌표)
    const pivot = turf.getCoord(turf.centroid(headland));

    // 축에 맞게 폴리곤 회전 각도 계산
    const angle = polygonOrientation(headland.geometry.coordinates[0]).toFixed(
      2
    );

    // 폴리곤 회전 (좌표축에 평행하도록 회전)
    const rotated = headland.geometry.coordinates[0].map((p) =>
      rotatePoint(p, pivot, -angle)
    );

    const rotatedPolygon = turf.polygon([rotated]);
    // 회전한 폴리곤의 바운딩 박스 처리
    const bbox = turf.bbox(rotatedPolygon);

    const [minX, minY, maxX, maxY] = bbox;

    // 바운딩 박스 내에 스와스 생성
    const swaths = [];

    /*
       for (let y = minY; y <= maxY; y += workingWidth) {
      const line = turf.lineString([
        [minX, y],
        [maxX, y],
      ]);
    */
    if (Direction === "X") {
      for (let x = minX; x <= maxX; x += workingWidth) {
        const line = turf.lineString([
          [x, minY],
          [x, maxY],
        ]);
        // console.log(line);

        // 회전한 폴리곤을 라인으로 변환
        const boundary = turf.polygonToLine(rotatedPolygon);

        // 폴리곤과 라인의 교점 찾기
        const clipped = turf.lineSplit(line, boundary);

        const insideSegments = clipped.features.filter((seg) => {
          const coords = seg.geometry.coordinates;
          const mid = midpointCartesian(coords[0], coords[1]);

          return turf.booleanPointInPolygon(mid, rotatedPolygon);
        });

        insideSegments.forEach((seg) => swaths.push(seg));
      }
    } else if (Direction === "Y") {
      for (let y = minY; y <= maxY; y += workingWidth) {
        const line = turf.lineString([
          [minX, y],
          [maxX, y],
        ]);
        // console.log(line);

        // 회전한 폴리곤을 라인으로 변환
        const boundary = turf.polygonToLine(rotatedPolygon);

        // 폴리곤과 라인의 교점 찾기
        const clipped = turf.lineSplit(line, boundary);

        const insideSegments = clipped.features.filter((seg) => {
          const coords = seg.geometry.coordinates;
          const mid = midpointCartesian(coords[0], coords[1]);

          return turf.booleanPointInPolygon(mid, rotatedPolygon);
        });

        insideSegments.forEach((seg) => swaths.push(seg));
      }
    }

    const finalSwaths = swaths.map((s) => {
      const coords = s.geometry.coordinates;
      // 스와스 회전
      const rotatedCoords = coords.map((p) => rotatePoint(p, pivot, angle));
      return turf.lineString(rotatedCoords);
    });

    return finalSwaths;
  } catch (err) {
    console.warn("Swaths 생성 오류:", err);
  }
};
